import { SVGProps } from "react";
import I18n from "common/i18n";
import { getTitleFont } from "common/utils/font";

// 日本語以外のタイトル。日本語は手描きの TopTitle をそのまま使うので、ここには来ない。
// 前半はオレンジ、後半は緑。外側に白いフチを付け、1文字ずつ上下にずらして
// 傾けることで、手描きの TopTitle と同じ弧の並びにする。
// 手描きの日本語は「紺色＋オレンジのフチ」だが、漢字や欧文だと線が潰れて濁るので、
// フチは白だけにして塗りをオレンジにしている。
const FILL_FRONT = "#FFA03B";
const FILL_BACK = "#2BDC98";
const STROKE_OUTER = "#FEFDFE";

/** 弧の高さ。中央がこのぶん持ち上がる */
const ARCH = 11;
/** 弧に沿わせる傾き（度） */
const TILT = 7;
/** 字間。白フチが太いので、空けないと隣の字とくっつく。
 *  欧文は字数が多く、漢字と同じだけ空けると枠からはみ出す */
const LETTER_SPACING_CJK = 14;
const LETTER_SPACING_LATIN = 2;
/** 字の大きさ。欧文は字数が多いので、白フチごと枠に収まるよう小さくする */
const FONT_SIZE_CJK = 78;
const FONT_SIZE_LATIN = 60;

const getParts = (): [string, string] => {
  switch (I18n.locale) {
    case "zh_tw":
      return ["自由", "創作"];
    case "zh_cn":
      return ["自由", "创作"];
    default:
      return ["Create ", "Freely"];
  }
};

/** 中央が高い弧。1文字ずつの上下のずれと傾きを返す */
const arch = (length: number) => {
  const offset = (i: number) => -ARCH * Math.sin((Math.PI * (i + 0.5)) / length);
  const dy = Array.from({ length }, (_, i) => (i === 0 ? offset(0) : offset(i) - offset(i - 1)));
  const rotate = Array.from({ length }, (_, i) => -TILT * Math.cos((Math.PI * (i + 0.5)) / length));
  return {
    dy: dy.map((v) => v.toFixed(2)).join(" "),
    rotate: rotate.map((v) => v.toFixed(2)).join(" "),
  };
};

export const TopTitleText = (props: SVGProps<SVGSVGElement>) => {
  const [front, back] = getParts();
  const isLatin = I18n.locale !== "zh_cn" && I18n.locale !== "zh_tw";
  const fontSize = isLatin ? FONT_SIZE_LATIN : FONT_SIZE_CJK;
  const { dy, rotate } = arch(front.length + back.length);

  const shared = {
    x: 273,
    y: 60,
    dy,
    rotate,
    textAnchor: "middle" as const,
    dominantBaseline: "central" as const,
    fontFamily: getTitleFont(),
    letterSpacing: isLatin ? LETTER_SPACING_LATIN : LETTER_SPACING_CJK,
    strokeLinejoin: "round" as const,
  };

  return (
    <svg viewBox="0 0 546 120" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {/* 外側の白フチ */}
      <text
        {...shared}
        fontSize={fontSize}
        fill={STROKE_OUTER}
        stroke={STROKE_OUTER}
        strokeWidth={26}
        style={{ paintOrder: "stroke", filter: "drop-shadow(1px 2px 2px rgba(63,74,97,0.25))" }}
      >
        {front}
        {back}
      </text>

      {/* 塗り */}
      <text {...shared} fontSize={fontSize}>
        <tspan fill={FILL_FRONT}>{front}</tspan>
        <tspan fill={FILL_BACK}>{back}</tspan>
      </text>
    </svg>
  );
};
